import { render, staticRenderFns } from "./RelatedPartySelectionModal.vue?vue&type=template&id=34b00d84&scoped=true"
import script from "./RelatedPartySelectionModal.vue?vue&type=script&lang=js"
export * from "./RelatedPartySelectionModal.vue?vue&type=script&lang=js"
import "./RelatedPartySelectionModal.vue?vue&type=style&index=0&id=34b00d84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b00d84",
  null
  
)

export default component.exports